export default "__VITE_ASSET__ov3kHVIk__"